import 'whatwg-fetch';
import { failureMsg } from './failure.js';
import { SHOW_QUESTIONS_EVENT } from './questions';

var $ = require('jquery');
import './scrollto'; // jquery plugin needs to come after jquery
var Cookies = require('js-cookie/src/js.cookie');

export var participantId;
export function setParticipantId(newId) {
    participantId = newId;
};

export function setupGate() {
    // choose gate treatment: form / no form
    if (!$('.asmt-signup-form').length) {
        attachNoFormEvents();
    } else {
        attachSignupFormEvents();
    }
}

function attachNoFormEvents() {
    $('.signup-button').click(function() {
        $(document).trigger(SHOW_QUESTIONS_EVENT);
    });
}

export function attachSignupFormEvents() {
    $('.asmt-signup-form').on('submit', function(e) {
        let $form = $(this);

        e.preventDefault();
        clearSignupFormErrors($form);
        signupButtonLoading($form, true);

        if ($form.data('submitted')) {
            return;
        } else {
            $form.data('submitted', true);
        }

        fetch($form.attr('action'), {
            credentials: 'same-origin',
            body: $form.serialize(), // we'd use FormData here, but no IE9 support
            method: $form.attr('method'),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'X-CSRFToken': Cookies.get('csrftoken')
            }
        })
        .then(
            function(response) {
                if (response.status !== 200) {
                    return failureMsg();
                }

                response.json().then(function(json) {
                    if (json.errors) {
                        displaySignupFormErrors($form, json.errors);
                        return;
                    }
                    if (json.registration_ok) {
                        // wish there was a solution w/o mutating non-local vars :-(
                        setParticipantId(json.participant_id);
                        signupComplete();
                    } else {
                        return failureMsg();
                    }
                });

                signupButtonLoading($form, false);
                $form.data('submitted', false);
            }
        )
        .catch(function() {
            return failureMsg();
        });

    });
}


function displaySignupFormErrors($form, errors) {
    let $errorsSummary = $form.find('.form-errors-summary');
    let errorCount = Object.keys(errors).length;

    $errorsSummary.removeClass('hidden').html(
        `This form contains ${errorCount} error` + (errorCount > 1 ? 's' : '') + '.'
    );

    for (let elementId in errors) {
        let $e = $('#' + elementId + ', #' + elementId + '_0');
        let $formGroup = $e.closest('.form-group');
        $formGroup.addClass('has-error');

        for (let error of errors[elementId]) {
            $formGroup.append(
                `<div class="form-field-error-msg control-label">${error}</div>`
            );
        }
    }

    $errorsSummary.scrollto(750);
}


function clearSignupFormErrors($form) {
    $form.find('.form-errors-summary').addClass('hidden');
    $form.find('.form-group').removeClass('has-error');
    $form.find('.form-field-error-msg').remove();
}


function signupComplete() {
    GEMG.SessionCoach.reload(true);
    $(document).trigger(SHOW_QUESTIONS_EVENT);
}


function signupButtonLoading($form, loading) {
    let $signupButton = $form.find('.signup-button');
    let $buttonWidth = $signupButton.outerWidth();

    if (loading) {
        $signupButton.addClass('disabled remove-hover');
        $signupButton.children().hide();
        if ($('html').hasClass('cssanimations')) {
            $signupButton.find('.loading .css-animations').show();
            $signupButton.find('.loading .no-css-animations').hide();
        } else {
            $signupButton.find('.loading .css-animations').hide();
            $signupButton.find('.loading .no-css-animations').show();
        }
        $signupButton.find('.loading').show();
        $signupButton.outerWidth($buttonWidth);
    } else {
        $signupButton.removeClass('disabled remove-hover');
        $signupButton.css('width', '');
        $signupButton.children().hide();
        $signupButton.children(':not(.loading)').show();
    }
}



// WEBPACK FOOTER //
// ./src/gate.js